import Skeleton from 'react-loading-skeleton'
import * as S from '../StampedReviews.styles'

export const StampedReviewsDesktopSkeleton = (): JSX.Element => {
  return (
    <S.DesktopMainContainer>
      <S.MainTitle>
        <Skeleton width={'35rem'} height={'4.4rem'} />
      </S.MainTitle>

      <S.MainDescription>
        <Skeleton width={'90%'} height={'2rem'} />
        <Skeleton width={'98%'} height={'2rem'} />
        <Skeleton width={'70%'} height={'2rem'} />
      </S.MainDescription>

      <S.ButtonContainer>
        <S.StarContainer>
          <Skeleton width={'4.4rem'} height={'3.5rem'} />
          <S.StarSkeleton count={5} wrapper={S.Star} />
          <Skeleton width={'11rem'} height={'1rem'} />
        </S.StarContainer>
        <Skeleton width={'23.3rem'} height={'3.8rem'} />
        <Skeleton width={'18.8rem'} height={'3.8rem'} />
      </S.ButtonContainer>

      <S.SortContainer>
        <Skeleton width={'12.4rem'} height={'1.2rem'} />
      </S.SortContainer>

      <S.TabsContainer>
        <Skeleton width={'9.5rem'} height={'1.9rem'} />
        <Skeleton width={'9.5rem'} height={'1.9rem'} />
      </S.TabsContainer>

      <S.ReviewsContainer>
        <S.Details>
          <Skeleton width={'8.2rem'} height={'1.8rem'} />
          <Skeleton count={5} wrapper={S.Star} height={'3.3rem'} />
          <Skeleton
            width={'5rem'}
            height={'1.7rem'}
            style={{ marginTop: '1.5rem' }}
          />
          <Skeleton
            width={'10rem'}
            height={'1.7rem'}
            style={{ marginTop: '2rem' }}
          />
          <S.Container style={{ marginTop: '2rem' }}>
            <Skeleton circle width={'1.2rem'} height={'1.2rem'} />
            <Skeleton width={'12rem'} height={'1.2rem'} />
          </S.Container>
        </S.Details>

        <S.ReviewText>
          <Skeleton
            width={'20rem'}
            height={'2.4rem'}
            style={{ marginBottom: '2rem' }}
          />
          <Skeleton width={'98%'} height={'2rem'} />
          <Skeleton width={'90%'} height={'2rem'} />
          <Skeleton width={'95%'} height={'2rem'} />
          <Skeleton width={'70%'} height={'2rem'} />
          <Skeleton width={'97%'} height={'2rem'} />
          <Skeleton width={'35%'} height={'2rem'} />
        </S.ReviewText>
      </S.ReviewsContainer>
    </S.DesktopMainContainer>
  )
}
